const COMPANY_INFO = {
  name: 'Intmed SRL',
  rnc: '131283721',
  address: 'Calle Altagracia Saviñón #1, Local #4, Los Prados, Santo Domingo, República Dominicana',
  phone: '809-566-6953',
  email: 'ventas@intmed.com.do',
  website: 'www.intmed.com.do',
};

export default COMPANY_INFO;
